module.exports = __webpack_public_path__ + "img/lobster.0b9613a4.svg";